/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import GenericTable from "@/common/components/ui/table/GenericTable";
import { numberToCurrency } from "@/common/helpers/currency.helpers";
import { formatDate, brDateHourFormat } from "@/common/helpers/date.helpers";
import { PAYMENT_STATUS } from "@/types/payment.type";
import Loading from "@/common/components/ui/loading/Loading";

interface TablePaymentsProps {
  payments: Record<string, unknown>[];
  renter: { _id?: string };
  tableHeaders: Record<string, string>;
  withInactiveStyle: (content: React.ReactNode, data: Record<string, any>) => React.ReactNode;
  getStatusLabels: (status: string) => string;
  actions?: any;
}

export function TablePayments({
  payments,
  actions,
  renter,
  tableHeaders,
  withInactiveStyle,
  getStatusLabels,
}: TablePaymentsProps) {
  if (!payments.length) {
    return <div> Nenhum pagamento registrado até o momento.</div>;
  }

  return renter._id ? (
    <GenericTable
      headers={tableHeaders}
      data={payments as unknown as Record<string, unknown>[]}
      actions={actions}
      renders={{
        description: (description, data) =>
          withInactiveStyle(description, data),

        value: (value, data) =>
          withInactiveStyle(numberToCurrency(value), data),

        dueDate: (date, data) =>
          withInactiveStyle(formatDate(date), data),

        paymentDate: (date, data) =>
          withInactiveStyle(date ? formatDate(date) : "-", data),

        status: (status) => {
          const label = getStatusLabels(status);
          let className = "";

          switch (status) {
            case PAYMENT_STATUS.RECEIVED:
              className = "text-greenDark font-semibold";
              break;
            case PAYMENT_STATUS.PENDING:
              className = "text-bluePrimary font-semibold";
              break;
            case PAYMENT_STATUS.OVERDUE:
              className = "text-redPrimary font-semibold";
              break;
            case PAYMENT_STATUS.Inativo:
              className = "text-gray";
              break;
            default:
              className = "";
          }

          return <span className={className}>{label}</span>;
        },

        invoiceUrl: (link, data) =>
          withInactiveStyle(
            <a href={link as string} target="_blank" rel="noopener noreferrer">link</a>,
            data
          ),

        paymentViewed: (date, data) =>
          withInactiveStyle(date ? brDateHourFormat(date) : "-", data)
      } as any}
      entity="edit-payment"
      role="finance"
    />
  ) : (
    <Loading />
  );
}